import { useQuery } from '@tanstack/react-query';
import { magicLoginService, AuthMethods } from '@/services/magic-login.service';

const OFF: AuthMethods = { magicLogin: false };

/**
 * Optional login methods enabled on the server. Any failure resolves to "everything off"
 * so the login page degrades to the plain password form.
 */
export const useAuthMethodsState = (): { methods: AuthMethods; isLoading: boolean } => {
  const { data, isLoading } = useQuery<AuthMethods>({
    queryKey: ['auth', 'methods'],
    queryFn: async () => {
      try {
        return await magicLoginService.getMethods();
      } catch {
        return OFF;
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return { methods: data ?? OFF, isLoading };
};

export const useAuthMethods = (): AuthMethods => useAuthMethodsState().methods;
